import { Grid, Typography } from "@material-ui/core";
import { makeStyles } from "@material-ui/core/styles";
import React, { useState, useEffect  } from "react";
import NotificacoesCabecalho from "../../../shared/components/NotificacoesCabecalho";
import AlertaMensagem from "../../../shared/components/AlertaMensagem";
import { Map, MapPin } from "react-feather";
import notificacoesManager from "../notificacoesManager";
import { configureEnvironment } from "../../../config/env";

const Notificacoes = (props) => {
	const [open, setOpen] = useState(false)
	const classes = useStyles(props)
	const [notificacoes, setNotificacoes] = useState([]);
  	const [novasNotificacoes, setNovasNotificacoes] = useState(false);

	useEffect(() => {
		const timeout = setTimeout(() => {
			obterNotificacoes();
		}, 1000);

		const interval = setInterval(() => {
			obterNotificacoes();
		}, 120000);

		return () => {
			clearInterval(interval);
			clearTimeout(timeout);
		};
	}, []);

	const obterNotificacoes = async () => {
		var { result } = await notificacoesManager.obterNotificacoes();
		setNotificacoes(result?.notificacoes ?? []);
		setNovasNotificacoes(result?.novasNotificacoes ?? false);
	};

	const handleClick = async () => {
		setOpen(prev => !prev);
		if (!open) {
			await notificacoesManager.registrarVisualizacaoNotificacoes();
			obterNotificacoes();
		}
	};

	const handleClickAway = () => {
		setOpen(false);
	};

	const handleClickNotificacao = codigoVuupt => {
		var url = configureEnvironment().REACT_MAPA_VUUPT + codigoVuupt;
		window.open(url, "_blank", "noreferrer");
	};

	const obterMensagem = notificacao => {
		if (notificacao.toString().toUpperCase() === "COLETOR A CAMINHO") {
			return "Coletor a caminho, acompanhe a coleta";
		}
		return "Existe uma rota programada para coleta em seu laboratório";
	};

	const obterIcone = notificacao => {
		if (notificacao.toString().toUpperCase() === "COLETOR A CAMINHO") {
			return <MapPin />;
		}
		return <Map />;
	};

	return (
		<>
			<NotificacoesCabecalho
				handleClickAway={handleClickAway}
				handleClick={handleClick}
				haNotificacoes={novasNotificacoes}
				open={open}
			>
				{notificacoes.map((notificacao, idx) => (
					<AlertaMensagem
						key={`notif-${idx}`}
						mensagem={obterMensagem(notificacao.notificacao)}
						handleClick={
							notificacao?.codigoVuupt
								? () => handleClickNotificacao(notificacao.codigoVuupt)
								: null
							}
						iconeMensagem={obterIcone(notificacao.notificacao)}
					/>
					))}
					{!notificacoes.length && (
						<Grid container>
							<Grid item className={classes.contentAlertMensage}>
								<Typography>Não há novas notificações</Typography>
							</Grid>
						</Grid>
				)}
			</NotificacoesCabecalho>
		</>
	)
}

const useStyles = makeStyles((theme) => ({
	contentAlertMensage: {
		padding: theme.spacing(3),
		width: "100%",
		color: "#23144D",
		fontSize: "0.75rem",
	},
}))

export default Notificacoes
